import * as actions from "store/actions";

const initialState = {
    previewState: {},
    serverState: {},
};

const WebchatBrandingElementsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.BRANDING_ELEMENTS_SAVED_TO_SERVER:
            return {
                ...state,
                serverState: action.payload
            };
        case actions.BRANDING_ELEMENTS_FETCHED_FROM_SERVER:
            return {
                ...state,
                previewState: action.payload, // TODO: This can cause conflicts and/or overwrite local changes
                serverState: action.payload
            };
        case actions.THEME_ITEM_UPDATED:
            return {
                ...state,
                previewState: {
                    ...state.previewState,
                    [action.payload.storeKey]: action.payload.newValue
                }
            };
        case actions.CHAT_ITEM_UPDATED:
            return {
                ...state,
                previewState: {
                    ...state.previewState,
                    [action.payload.storeKey]: action.payload.newValue
                }
            };
        case actions.PWA_ITEM_UPDATED:
            return {
                ...state,
                previewState: {
                    ...state.previewState,
                    [action.payload.storeKey]: action.payload.newValue
                }
            };
        case actions.LINK_ITEM_UPDATED:
            return {
                ...state,
                previewState: {
                    ...state.previewState,
                    [action.payload.storeKey]: action.payload.newValue
                }
            };
        default:
            return state;
    }
};

export default WebchatBrandingElementsReducer;